import React, { useEffect, useState } from 'react'
import PageCard from '../../common/PageCard'
import Page from '../../common/Page'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import MaterialInput from '../../common/MaterialInput'
import { COUNTRY_CODES } from '../../../consts'
import Actions from '../../../actions'
import { isEmpty } from 'ramda'
import { event, eventTypes } from '../../../consts/eventConsts'
import { formatClientSideError } from '../../../utils/eventUtils'
import inviteFamilyImg from '../../../resources/invite_family.svg'
import { Button } from 'antd'

import './InviteToApp.css'

const getValidationErrors = ({ phoneNumber }) => {
  const result = {}
  const numericRegex = /^\d{10}$/

  if (!phoneNumber.match(numericRegex)) {
    result.phoneNumber = $t('errors.validation.invalidPhone')
  }

  if (!phoneNumber) {
    result.phoneNumber = $t('errors.validation.missing')
  }

  return (!isEmpty(result) && result) || null
}

const InviteToApp = () => {
  const dispatch = useDispatch()

  const members = useSelector(state => state.account.members)
  const userDetails = useSelector(state => state.profile.userDetails)
  const {
    isInviteToDownloadAppLoading,
    inviteToDownloadAppPatientId,
    inviteToDownloadAppError,
  } = useSelector(state => state.app)

  const [phoneNumber, setPhoneNumber] = useState({
    short: 'US',
    code: COUNTRY_CODES[0],
    phone: '',
  })

  const [shouldValidate, setShouldValidate] = useState(false)

  // go back in case no patient id or after the invite to download app is done
  useEffect(() => {
    if (!inviteToDownloadAppPatientId) {
      dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteToDownloadAppPatientId])

  const errors =
    shouldValidate && getValidationErrors({ phoneNumber: phoneNumber?.phone })

  const isSelf =
    userDetails?.id?.toString() === inviteToDownloadAppPatientId?.toString()

  const currentPatient = isSelf
    ? userDetails
    : members?.find(
        patient =>
          patient?.id?.toString() === inviteToDownloadAppPatientId?.toString()
      )

  const currentPatientName = currentPatient?.firstName

  const onSubmit = () => {
    // remove '-' and '.' chars from number, is exists. remove spaces
    const phoneWithoutChars = phoneNumber?.phone
      ? phoneNumber?.phone
          .toString()
          .replace(new RegExp('[-.]', 'g'), '')
          .replace(/\s/g, '')
      : ''

    const payload = {
      phoneNumber: '+' + phoneNumber?.code.toString() + phoneWithoutChars,
      patientId: inviteToDownloadAppPatientId,
    }

    const validationErrors = getValidationErrors({
      phoneNumber: phoneWithoutChars,
    })

    if (validationErrors) {
      setShouldValidate(true)
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.invalid,
          data: payload,
          element: 'invite to download app',
          error: formatClientSideError(getValidationErrors(payload)),
        })
      )
      return
    }

    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: payload,
        element: 'invite to download app',
      })
    )

    dispatch(
      Actions.createAction(
        Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_REQUESTED,
        payload
      )
    )
  }

  return (
    <PageCard className="invite-app-page-card" enableBack={true}>
      <Page
        className="invite-app-page"
        title={$t('pages.inviteApp.title', { name: currentPatientName })}
        subtitle={$t('pages.inviteApp.subtitle', { name: currentPatientName })}
        hideAlertBanner={true}
        image={inviteFamilyImg}
      >
        <MaterialInput
          className="patient-phonenumber"
          label={$t('pages.getStarted.signupForm.phoneNumber')}
          type="phone"
          onChange={setPhoneNumber}
          disabled={isInviteToDownloadAppLoading}
          value={phoneNumber}
          errorText={errors?.phoneNumber}
        />
        {inviteToDownloadAppError && (
          <div className="invite-to-app-error">
            {$t('errors.somethingWentWrong')}
          </div>
        )}
        <Button
          type="primary"
          onClick={onSubmit}
          loading={isInviteToDownloadAppLoading}
        >
          {$t('pages.inviteApp.send')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default InviteToApp
